import RemoveDemoAccessModal from './RemoveDemoAccessModal';

export { default as useRemoveDemoAccess } from './useRemoveDemoAccess';

export default RemoveDemoAccessModal;
